/* eslint-disable no-nested-ternary */
import CardWithTitle from 'components/CardWithTitle';
import DateFormatter from 'components/DateFormatter';
import UserInfo from 'components/UserInfo';
import React, { useState } from 'react';
import { MdOutlineExpandLess, MdOutlineExpandMore } from 'react-icons/md';
import { Button, Col, Collapse, Label, Row } from 'reactstrap';

const OrderBiddingDetails = ({ bid }) => {
  const [isOpen, setIsOpen] = useState(false);
  const bidToggle = () => setIsOpen(!isOpen);
  return (
    <CardWithTitle title="Bidding Details">
      {bid?.bidder && (
        <div
          className={`order-bid-row mb-2 ${
            bid?.status === 'BID_ACCEPTED' ? (isOpen ? '' : 'accept') : ''
          }`}
        >
          <Row>
            <Col>
              <div className="d-flex align-items-start">
                <Button
                  color="link"
                  className="text-dark text-decoration-none p-0"
                  onClick={bidToggle}
                >
                  {bid?.childBids.length ? (
                    isOpen ? (
                      <MdOutlineExpandLess size={22} />
                    ) : (
                      <MdOutlineExpandMore size={22} />
                    )
                  ) : (
                    ''
                  )}
                </Button>
                <div>
                  <Label className="font-manrope text-gray f-12 fw-semibold d-block mb-1">
                    {bid?.bidderRole}
                  </Label>
                  <span className="f-12 fw-medium form-label d-block">
                    <UserInfo
                      name={
                        bid?.bidder?.entityName
                          ? bid?.bidder?.entityName
                          : 'N/A'
                      }
                      mobileNumber={
                        bid?.bidder?.phone
                          ? `${bid?.bidder?.callingCode?.callingCode}-${bid?.bidder?.phone}`
                          : 'N/A'
                      }
                    />
                    {}
                  </span>
                </div>
              </div>
            </Col>
            <Col>
              <div className="ms-2">
                <Label className="font-manrope text-gray f-12 fw-semibold d-block mb-1">
                  LOCATION{' '}
                </Label>
                <span className="f-12 fw-medium form-label d-block">
                  {bid?.bidder?.addresses[0]?.city?.cityName}
                  <span className="text-active d-block">
                    {' '}
                    {bid?.bidder?.addresses[0]?.state?.stateName}
                  </span>
                </span>
              </div>
            </Col>
            <Col>
              <div className="ms-2">
                <Label className="font-manrope text-gray f-12 fw-semibold d-block mb-1">
                  BID{' '}
                </Label>
                <span className="f-12 fw-medium form-label d-block">
                  {' '}
                  {bid?.rateUnit?.isoCurrencyCode} {bid?.price} at{' '}
                  {bid?.quantity}
                  {bid?.quantityUnit}{' '}
                </span>
              </div>
            </Col>
            <Col>
              {' '}
              <Label className="font-manrope text-uppercase  text-gray f-12 fw-semibold d-block mb-1">
                created AT{' '}
              </Label>{' '}
              <span className="f-12 fw-medium form-label d-block">
                <DateFormatter dateTime={bid?.createdAt} />
              </span>
            </Col>
          </Row>
          <Collapse isOpen={isOpen}>
            {bid?.childBids &&
              bid?.childBids.map((item) => {
                return (
                  <div
                    className={`order-bid-row  ${
                      item?.status === 'BID_ACCEPTED' ? 'accept' : ''
                    }`}
                    key={item.id}
                  >
                    <Row>
                      <Col>
                        <Label className="font-manrope text-gray f-12 fw-semibold d-block">
                          {item?.bidderRole}
                        </Label>{' '}
                        <span className="f-12 fw-medium form-label d-block">
                          <UserInfo
                            name={
                              item?.bidder?.entityName
                                ? item?.bidder?.entityName
                                : 'N/A'
                            }
                            mobileNumber={
                              item?.bidder?.phone
                                ? `${item?.bidder?.callingCode?.callingCode}-${item?.bidder?.phone}`
                                : 'N/A'
                            }
                          />
                        </span>
                      </Col>
                      <Col>
                        <div className="ms-2">
                          <Label className="font-manrope text-gray f-12 fw-semibold d-block mb-1">
                            LOCATION{' '}
                          </Label>
                          <span className="f-12 fw-medium form-label d-block">
                            {item?.bidder?.addresses[0]?.city?.cityName}
                            <span className="text-active d-block">
                              {' '}
                              {item?.bidder?.addresses[0]?.state?.stateName}
                            </span>
                          </span>
                        </div>
                      </Col>
                      <Col>
                        <Label className="font-manrope text-gray f-12 fw-semibold d-block">
                          BID{' '}
                        </Label>
                        <span className="f-12 fw-medium form-label d-block">
                          {item?.rateUnit?.isoCurrencyCode} {item?.price} at{' '}
                          {item?.quantity}
                          {item?.quantityUnit}
                        </span>
                      </Col>
                      <Col>
                        <Label className="font-manrope text-uppercase  text-gray f-12 fw-semibold d-block mb-1">
                          created AT{' '}
                        </Label>{' '}
                        <span className="f-12 fw-medium form-label d-block">
                          {' '}
                          <DateFormatter dateTime={item?.createdAt} />
                        </span>
                      </Col>
                    </Row>
                  </div>
                );
              })}
          </Collapse>
        </div>
      )}
    </CardWithTitle>
  );
};

export default OrderBiddingDetails;
